module.exports = __webpack_public_path__ + "static/img/S.a253d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mszj/S.png
// module id = TQBj
// module chunks = 0